import * as types from 'src/store/mutation-types'

function itemsFromResponse (items) {
  return items.map(block => {
    if (block.type !== 'table') {
      return block
    }

    return {
      ...block,
      children: block.children.map(group => ({
        ...group,
        children: group.children.map(lineItem => ({
          ...lineItem,
          id: lineItem.id,
          itemName: lineItem.item_name,
          price: lineItem.price,
          quantity: lineItem.quantity,
          salesTax: lineItem.sales_tax,
          description: lineItem.description,
          itemNumber: lineItem.item_number,
          discountAbsolute: lineItem.discount_absolute,
          discountRelative: lineItem.discount_relative,
          unitName: lineItem.unit_name
        }))
      }))
    }
  })
}

const getDefaultState = () => {
  return {
    items: [
      {
        type: 'table',
        children: [
          { type: 'group', heading: null, children: [] }
        ]
      }
    ],
    activeLineItem: null,
    showItemForm: false
  }
}

const state = getDefaultState()

const getters = {
  items: state => state.items,
  activeLineItem: state => state.activeLineItem,
  showItemForm: state => state.showItemForm
}

const actions = {
  resetState ({ commit }) {
    commit(types.CREATE_INVOICE_RESET)
  },

  setItems ({ commit }, items) {
    commit(types.CREATE_INVOICE_SET_ITEMS, items)
  },

  loadItems ({ commit }, items) {
    const mappedItems = itemsFromResponse(items)
    commit(types.CREATE_INVOICE_SET_ITEMS, mappedItems)
  },

  addLineItemsBlock ({ commit }) {
    const block = { type: 'group', heading: null, children: [] }
    commit(types.CREATE_INVOICE_ADD_BLOCK, block)
  },

  deleteBlock ({ commit }, index) {
    commit(types.CREATE_INVOICE_DELETE_BLOCK, index)
  },

  setActiveLineItem ({ commit }, item) {
    commit(types.CREATE_INVOICE_SET_ACTIVE_LINE_ITEM, item)
  },

  updateActiveLineItem ({ commit }, item) {
    commit(types.CREATE_INVOICE_UPDATE_ACTIVE_LINE_ITEM, item)
  },

  clearActiveLineItem ({ commit }) {
    commit(types.CREATE_INVOICE_SET_ACTIVE_LINE_ITEM, null)
  },

  addLineItem ({ commit }, item) {
    commit(types.CREATE_INVOICE_ADD_LINE_ITEM, item)
  },

  deleteLineItem ({ commit }, { groupIndex, itemIndex }) {
    commit(types.CREATE_INVOICE_DELETE_LINE_ITEM, { groupIndex, itemIndex })
  },

  showCreateItemForm ({ commit }) {
    commit(types.CREATE_INVOICE_SET_SHOW_ITEM_FORM, true)
  },

  cancelItemForm ({ commit }) {
    commit(types.CREATE_INVOICE_SET_SHOW_ITEM_FORM, false)
  },

  updateGroup ({ commit }, { groupIndex, value }) {
    commit(types.CREATE_INVOICE_UPDATE_GROUP, { groupIndex, value })
  },

  updateGroupHeading ({ commit }, { groupIndex, heading }) {
    commit(types.CREATE_INVOICE_UPDATE_GROUP_HEADING, { groupIndex, heading })
  }
}

const mutations = {
  [types.CREATE_INVOICE_SET_ITEMS] (state, items) {
    state.items = items
  },

  [types.CREATE_INVOICE_ADD_BLOCK] (state, block) {
    state.items[0].children.push(block)
  },

  [types.CREATE_INVOICE_DELETE_BLOCK] (state, index) {
    state.items[0].children.splice(index, 1)
  },

  [types.CREATE_INVOICE_SET_ACTIVE_LINE_ITEM] (state, item) {
    state.activeLineItem = item
  },

  [types.CREATE_INVOICE_UPDATE_ACTIVE_LINE_ITEM] (state, item) {
    Object.assign(state.activeLineItem, item)
  },

  [types.CREATE_INVOICE_ADD_LINE_ITEM] (state, item) {
    const lastBlockIndex = state.items[0].children.length - 1
    state.items[0].children[lastBlockIndex].children.push(item)
  },

  [types.CREATE_INVOICE_DELETE_LINE_ITEM] (state, { groupIndex, itemIndex }) {
    state.items[0].children[groupIndex].children.splice(itemIndex, 1)
  },

  [types.CREATE_INVOICE_SET_SHOW_ITEM_FORM] (state, value) {
    state.showItemForm = value
  },

  [types.CREATE_INVOICE_UPDATE_GROUP] (state, { groupIndex, value }) {
    state.items[0].children[groupIndex].children = value
  },

  [types.CREATE_INVOICE_UPDATE_GROUP_HEADING] (state, { groupIndex, heading }) {
    state.items[0].children[groupIndex].heading = heading
  },

  [types.CREATE_INVOICE_RESET] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
